<script setup>
import { ref, onMounted, onServerPrefetch } from 'vue'
import { storeToRefs } from 'pinia'
import SectionTitle from './SectionTitle.vue'
import { useGetData } from '../composable/useGetData.js'
import { useStore } from '../store.js'
import { useCommon } from '../composable/useCommon.js'

const store = useStore()
const { areaPrefList } = storeToRefs(store)
const props = defineProps({
  devDomains: { type: Object, default: () => {} },
  areaListTitle: { type: String, default: '各エリアの天気予報' },
  isWebViewProp: { type: Boolean, default: false },
  appViewShow: { type: Boolean, default: true }
})

const { isWebView } = useCommon()
const isWebViewFlag = ref(props.isWebViewProp)

const { getPrefTable } = useGetData(props.devDomains)

onServerPrefetch(async () => {
  areaPrefList.value = await getPrefTable()
})

onMounted(async () => {
  isWebViewFlag.value = isWebView()
  if (!areaPrefList.value) areaPrefList.value = await getPrefTable()
})

</script>

<template>
  <section
    v-if="areaPrefList?.length > 0 && (!isWebViewFlag || appViewShow)"
    class="spotlist"
  >
    <SectionTitle :title="areaListTitle" />
    <ul class="block">
      <li
        v-for="area in areaPrefList"
        :key="area.area_jp"
        class="list"
      >
        <a
          :href="area.link"
          class="title"
        >{{ area.area_jp }}</a>
        <ul
          v-if="area.pref_list.length > 0"
          class="parents"
        >
          <li
            v-for="pref in area.pref_list"
            :key="pref.pref_jp"
            class="inner"
          >
            <a
              :href="pref.link"
              class="link"
            >{{ pref.pref_jp }}</a>
            <p
              v-if="pref.city_list.length > 0"
              class="text"
            >
              (
            </p>
            <ul
              v-if="pref.city_list.length > 0"
              class="children"
            >
              <li
                v-for="city in pref.city_list"
                :key="city.city_jp"
                class="child"
              >
                <a
                  :href="city.link"
                  class="link"
                >{{ city.city_jp }}</a>
              </li>
            </ul>
            <p
              v-if="pref.city_list.length > 0"
              class="text"
            >
              )
            </p>
          </li>
        </ul>
      </li>
    </ul>
  </section>
</template>

<style lang="scss" scoped>
.spotlist {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .block {
    display: flex;
    flex-direction: column;
    border-radius: 6px;
    overflow: hidden;
  }
  .list {
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 8px 10px;
    background-color: #f9f9f9;
    &:nth-child(2n) {
      background-color: #eef1f8;
    }
  }
  .inner {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 3px;
  }
  .title {
    display: block;
    min-width: 53px;
    padding: 7px;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / .15);
    color: #303030;
    font-size: 13px;
    font-weight: 600;
    line-height: 1em;
    text-align: center;
  }
  .link {
    display: block;
    color: #3569c0;
    font-size: 14px;
    font-weight: 600;
    line-height: 1em;
    text-decoration: underline;
  }
  .parents {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    flex: 1;
  }
  .children {
    display: flex;
    align-items: center;
    gap: .7em;
  }
  .child {
    position: relative;
    &:not(:first-child)::before {
      position: absolute;
      top: 0;
      left: -.9em;
      width: 1em;
      height: 100%;
      color: #303030;
      font-size: 14px;
      font-weight: 600;
      line-height: 1em;
      content: '・';
    }
  }
  .text {
    color: #303030;
    font-size: 14px;
    font-weight: 600;
    line-height: 1em;
  }
  @media screen and (min-width: 830px) {
    .title {
      font-size: 13px;
      letter-spacing: normal;
      transition: box-shadow .2s ease-in-out;
      &:hover {
        box-shadow: 0 2px 6px 0 rgb(0 0 0 / .45);
      }
    }
    .link {
      transition: opacity .2s ease-in-out;
      &:hover {
        opacity: .6;
      }
    }
  }
}
</style>
